import { defineMessages } from '@transcend-io/internationalization';

export const loginMessages = defineMessages(
  'privacy-center.containers.Login.login',
  {
    logIn: {
      defaultMessage: 'Verify your identity',
    },
  },
);
